import src from "IMAGE";
export default { src, width: 300, height: 67, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAM0lEQVR42i3HoQ0AIBAEwWuJRkgwaKpAfhAUgEZ/ob/ixGSzkvQQWJjoGG6DPo6b2Lj+KNW4B02U8Nt7AAAAAElFTkSuQmCC"};
